import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { HelmetProvider } from "react-helmet-async";
import { useTheme } from "./Hooks/useTheme";
import AppRoutes from "./Routes/AppRoutes";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import { lightTheme, darkTheme } from "./Styles/muiTheme";
import { ToastProvider } from "./admin/context/ToastContext";

const AppContent: React.FC = () => {
  const { theme } = useTheme();
  const muiTheme = theme === "dark" ? darkTheme : lightTheme;

  return (
    <MuiThemeProvider theme={muiTheme}>
      <BrowserRouter>
        <ToastProvider>
          <div className="App">
            <main className="main">
              <AppRoutes />
            </main>
            <ScrollToTop />
          </div>
        </ToastProvider>
      </BrowserRouter>
    </MuiThemeProvider>
  );
};

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <AppContent />
    </HelmetProvider>
  );
};

export default App;
